(function() {
    angular.module('tmx-app').controller('rateUploadCtrl', ['$state', 'ProductRateDetailService','$mdSidenav','tmxUtility','menu', 
    
        function RateUploadCtrl($state, ProductRateDetailService, $mdSidenav,tmxUtility,menu) {
            var rateUploadVM = this;
            var exists;
            var copy;
            exists = tmxUtility.exists;
            copy = tmxUtility.copy;
            rateUploadVM.menu = menu;     
            rateUploadVM.checkPermission = tmxUtility.checkPermission;       
            rateUploadVM.ProductRateDetailService = ProductRateDetailService;
            rateUploadVM.cols = ProductRateDetailService.gridColumn;
            rateUploadVM.nav = "SearchSideNav";
            rateUploadVM.gridData = new kendo.data.ObservableArray([]);  
            rateUploadVM.gridColumns = angular.copy(ProductRateDetailService.columns);
            rateUploadVM.TimeStampFormatting = tmxUtility.formatDateTimeForCompany;
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

            rateUploadVM.isFiltered=function(fieldName){
                var filtered = false;    
                if(angular.isDefined(rateUploadVM.filters)) {
                    rateUploadVM.filters.filters.forEach(function(filter){
                        if(filter.field==fieldName) {
                            filtered = true;
                        }         
                    });
                }
                return filtered;
            }  

            rateUploadVM.reload = function() {
                rateUploadVM.container.RateUploadGrid.dataSource.read();
            };

            rateUploadVM.success=function(promise){
                if(promise.read==true) {
                    rateUploadVM.container.RateUploadGrid.dataSource.transport.read(promise);
                }
                else {
                    rateUploadVM.container.RateUploadGrid.dataSource.read(); 
                }
                rateUploadVM.toggleSearch(rateUploadVM.nav);
            };

            rateUploadVM.afterImport = function() {
                rateUploadVM.reload();
            }

            rateUploadVM.toggle = function(navID) {
                $mdSidenav(navID)
                    .toggle()
                    .then(function() {});
            };
         
            rateUploadVM.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function(o) {
                            if(angular.isDefined(rateUploadVM.searchClear) && rateUploadVM.searchClear==false){
                                if(exists(rateUploadVM.o)){
                                    copy(rateUploadVM.o.data,["filter"],o.data);
                                }
                            }
                            rateUploadVM.searchClear = false;
                            if(!o.fromSideNav) {
                                if($state.searchClear){
                                    rateUploadVM.searchClear = true;
                                    $state.searchClear=undefined;
                                }
                            }
                            else
                                o.data.firstPage = true;
                            rateUploadVM.o = angular.copy(o);             
                            rateUploadVM.filters = rateUploadVM.o.data.filter;
                            ProductRateDetailService.getByParams(o, true).then(function(response) {
                                parseResppnse(response.data);
                                o.success(response);
                            });
                        },
                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "Total"
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,

                    sort:  [{field: "CreatedDate", dir: "desc"}],
                },
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    pageSize: 10,
                    buttonCount: 5
                },
                pdf: {
                    allPages: true,
                    fileName: "RateUpload.pdf"
                },
                excel: {
                    fileName: "RateUpload.xlsx"
                },
                sortable: true,
                scrollable: false,
                columns: rateUploadVM.gridColumns
            };


            function parseResppnse(data){
                data.forEach(function(dataItem){                                        
                    dataItem.CreatedDate = rateUploadVM.TimeStampFormatting(dataItem.CreatedDate);                          
                });
            }
        }]);
})();
